<template>
  <div v-if="showPage" class="weighbridgeSysIndex">
    <div class="top-cont">
      <span class="s1 licensePlate">{{ bookingObj.license_plate }}</span>
      <span class="s2">料品称重验收单</span>
    </div>
    <div class="top-cont-text">
      <div class="left">预约单号：</div>
      <div class="right">{{ valformateEmpty(bookingObj.id) }}</div>
    </div>
    <div class="top-cont-text">
      <div class="left">车牌号：</div>
      <div class="right">{{ valformateEmpty(bookingObj.license_plate) }}</div>
    </div>
    <div class="top-cont-text">
      <div class="left">业务大类：</div>
      <div class="right">
        {{ valformateEmpty(bookingObj.main_business.name) }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">业务子类：</div>
      <div class="right">{{ subBusinessName }}</div>
    </div>
    <div class="materielListDiv">
      <div class="title">
        共{{ bookingObj.pound.length }}个料品，已验收
        <span class="s1">{{ checkNumber }}</span
        >个
      </div>
      <div class="bookingCodeDiv">
        <template v-for="(item, index) in bookingObj.pound">
          <div :key="index">
            <van-button
              @click="showIndex = index"
              v-if="index == showIndex"
              type="primary"
              >{{ valformateEmpty(item.receipt_number) }}</van-button
            >
            <van-button
              @click="showIndex = index"
              v-else
              plain
              type="primary"
              >{{
                valformateEmpty(
                  item.receipt_number.substring(item.receipt_number.length - 10)
                )
              }}</van-button
            >
          </div>
        </template>
      </div>
      <van-divider />
      <div class="bookingListDiv">
        <template v-for="(item, index) in bookingObj.pound">
          <div v-show="index == showIndex" :key="index" class="bookingItem">
            <div class="top-cont-text">
              <div class="left">入库单号：</div>
              <div class="right">
                {{ valformateEmpty(item.receipt_number) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">料品编号：</div>
              <div class="right">
                {{ valformateEmpty(item.inventory_code) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">料品名称：</div>
              <div class="right">
                {{ valformateEmpty(item.inventory_name) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">计量单位：</div>
              <div class="right">
                {{ valformateEmpty(item.inventory_unit) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">毛重：</div>
              <div class="right">
                {{ item.rough_weight }}
                {{ item.inventory_unit }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">皮重：</div>
              <div class="right">
                {{ item.tare_weight }}
                {{ item.inventory_unit }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">净重：</div>
              <div class="right">
                {{ item.net_weight }}
                {{ item.inventory_unit }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">收货仓库：</div>
              <div class="right">
                {{ valformateEmpty(item.warehouse_name) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">入场时间：</div>
              <div class="right">{{ entryTime(item.entry_time) }}</div>
            </div>
            <div class="top-cont-text">
              <div class="left">入库时间：</div>
              <div class="right">
                {{ entryTime(item.entry_warehouse_time) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">地磅操作人：</div>
              <div class="right">{{ valformateEmpty(item.receiver_name) }}</div>
            </div>

            <template v-if="item.state == 1">
              <div class="top-cont-text">
                <div class="left">验收状态：</div>
                <div class="right">{{ poundState(item.state) }}</div>
              </div>
              <div class="top-cont-text">
                <div class="left">验收人：</div>
                <div class="right">
                  {{ valformateEmpty(item.acceptance_user_name) }}
                </div>
              </div>
              <div class="top-cont-text">
                <div class="left">验收时间：</div>
                <div class="right">
                  {{ acceptanceTime(item.acceptance_time) }}
                </div>
              </div>
            </template>
            <div class="itemAction" v-if="item.state == 0">
              <van-button @click="checkWeighbridge(item)" type="primary"
                >验收此物料</van-button
              >
            </div>
          </div>
        </template>
        <div v-if="bookingObj.pound.length == 0">
          <Empty></Empty>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="confirmShow"
      title="确认提示"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          确定验收料品“
          <span class="colorPink">{{ checkWeighbridgeName }}</span>
          ”吗？
          <br />确认前请核实重量是否准确无误！
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="confirmShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1;" @click="saveAppoint">
            <van-button block class="dialogBtnConfirm">确认提交</van-button>
          </div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Empty from "@/components/tips/Empty.vue";
export default {
  props: {},
  data() {
    return {
      booking_id: "",
      bookingObj: {},
      showPage: false,
      showIndex: 0,
      checkWeighbridgeName: "",
      confirmShow: false,
      checkWeighbridgeItem: {}
    };
  },
  watch: {},
  computed: {
    checkNumber() {
      let num = 0;
      this.bookingObj.pound.forEach(element => {
        if (Number(element.state) == 1) {
          num++;
        }
      });
      return num;
    },
    entryTime() {
      return t => {
        if (t.length > 0) {
          return moment(t).format("YYYY年MM月DD日 HH:mm:ss");
        } else {
          return "--";
        }
      };
    },
    acceptanceTime() {
      return t => {
        if (Number(t) > 0) {
          return moment.unix(t).format("YYYY年MM月DD日 HH:mm:ss");
        } else {
          return "--";
        }
      };
    },
    subBusinessName() {
      let sub_business = "";
      this.bookingObj.sub_business.forEach((element, index) => {
        sub_business = sub_business + element.name;
        if (index != this.bookingObj.sub_business.length - 1) {
          sub_business = sub_business + ";";
        }
      });
      if (sub_business.length == 0) {
        sub_business = "--";
      }
      return sub_business;
    },
    poundState() {
      return val => {
        let text = "";
        if (val == 0) {
          text = "未验收";
        }
        if (val == 1) {
          text = "已验收";
        }
        return text;
      };
    },
    valformateEmpty() {
      return val => {
        if (val == undefined || val == "undefined" || val == "") {
          return "--";
        } else {
          return val;
        }
      };
    }
  },
  components: {
    Empty
  },
  async mounted() {},
  methods: {
    getBookingObj() {
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_pound",
          data: {
            booking_id: this.booking_id
          }
        })
        .then(res => {
          console.log(JSON.stringify(res.data.data));
          this.bookingObj = res.data.data;
          this.showPage = true;
        });
    },
    saveAppoint() {
      let pound_id = this.checkWeighbridgeItem.id;
      this.$common
        .http({
          url: "/api/queue/warehouseman/acceptance_pound",
          data: {
            pound_id
          }
        })
        .then(() => {
          // this.bookingObj[this.showIndex].state = 1;
          this.getBookingObj();
          this.confirmShow = false;
        });
    },
    checkWeighbridge(item) {
      this.checkWeighbridgeName = item.inventory_name;
      this.confirmShow = true;
      this.checkWeighbridgeItem = item;
    }
  },
  created() {
    this.booking_id = this.$route.query.booking_id;
    this.getBookingObj();

    // this.bookingObj = {
    //   id: "0ea8e8dad61349479f7e33b286e5102a",
    //   license_plate: "宁978944",
    //   main_business: {
    //     id: "6b659440f6ec4d8a8d94881718b963be",
    //     name: "华丰厂-成品出厂",
    //     type: 1
    //   },
    //   sub_business: [
    //     {
    //       id: "2c42de87812a4d4db807bf56fde14771",
    //       name: "7成品出厂-禁用",
    //       type: 1
    //     },
    //     {
    //       id: "3fea56a2fcd14be9aa3b15ac6c0e33e1",
    //       name: "3成品出厂-子",
    //       type: 1
    //     },
    //     {
    //       id: "439e1f9a47844bf095264311a7b7858b",
    //       name: "1成品出厂-子",
    //       type: 1
    //     },
    //     {
    //       id: "4d3aed8adb7d46c09958f53bedef792b",
    //       name: "5成品出厂-子",
    //       type: 1
    //     },
    //     {
    //       id: "6b14c91682404e3c91785ddf34e815ca",
    //       name: "2成品出厂-子",
    //       type: 1
    //     },
    //     {
    //       id: "d415569451e04923b33f3b0b819533ea",
    //       name: "6成品出厂-莫动",
    //       type: 1
    //     },
    //     {
    //       id: "f03dd425a2db4f0bb0de10e87b401b13",
    //       name: "4成品出厂-子",
    //       type: 1
    //     }
    //   ],
    //   pound: [
    //     {
    //       id: "a9ac3a821d7249f3aec6a46249fdd33a",
    //       booking_id: "0ea8e8dad61349479f7e33b286e5102a",
    //       create_time: 1608708019,
    //       update_time: 1608708019,
    //       info_state: 1,
    //       license_plate: "宁978944",
    //       receipt_number: "0000000440A",
    //       warehouse_name: "TSW原料仓",
    //       entry_warehouse_time: "2020-12-23 00:00:00.000",
    //       rough_weight: 50,
    //       tare_weight: 20,
    //       net_weight: 30,
    //       receiver_name: "0000000440A",
    //       entry_time: "2020-12-23 15:17:15.693",
    //       inventory_code: "1010-00000-008",
    //       inventory_name: "测试自由",
    //       inventory_unit: "pcs",
    //       state: 0,
    //       acceptance_time: 0,
    //       acceptance_user_id: "",
    //       acceptance_user_name: null
    //     },
    //     {
    //       id: "a9ac3a821d7249f3aec6a46249fdd33a",
    //       booking_id: "0ea8e8dad61349479f7e33b286e5102a",
    //       create_time: 1608708019,
    //       update_time: 1608708019,
    //       info_state: 1,
    //       license_plate: "宁978944",
    //       receipt_number: "0000000440A",
    //       warehouse_name: "TSW原料仓",
    //       entry_warehouse_time: "2020-12-23 00:00:00.000",
    //       rough_weight: 50,
    //       tare_weight: 20,
    //       net_weight: 30,
    //       receiver_name: "0000000440A",
    //       entry_time: "2020-12-23 15:17:15.693",
    //       inventory_code: "1010-00000-008",
    //       inventory_name: "测试自由",
    //       inventory_unit: "pcs",
    //       state: 0,
    //       acceptance_time: 0,
    //       acceptance_user_id: "",
    //       acceptance_user_name: null
    //     },
    //     {
    //       id: "a9ac3a821d7249f3aec6a46249fdd33a",
    //       booking_id: "0ea8e8dad61349479f7e33b286e5102a",
    //       create_time: 1608708019,
    //       update_time: 1608708019,
    //       info_state: 1,
    //       license_plate: "宁978944",
    //       receipt_number: "0000000440A",
    //       warehouse_name: "TSW原料仓",
    //       entry_warehouse_time: "2020-12-23 00:00:00.000",
    //       rough_weight: 50,
    //       tare_weight: 20,
    //       net_weight: 30,
    //       receiver_name: "0000000440A",
    //       entry_time: "2020-12-23 15:17:15.693",
    //       inventory_code: "1010-00000-008",
    //       inventory_name: "测试自由",
    //       inventory_unit: "pcs",
    //       state: 0,
    //       acceptance_time: 0,
    //       acceptance_user_id: "",
    //       acceptance_user_name: null
    //     },
    //     {
    //       id: "a9ac3a821d7249f3aec6a46249fdd33a",
    //       booking_id: "0ea8e8dad61349479f7e33b286e5102a",
    //       create_time: 1608708019,
    //       update_time: 1608708019,
    //       info_state: 1,
    //       license_plate: "宁978944",
    //       receipt_number: "0000000440A",
    //       warehouse_name: "TSW原料仓",
    //       entry_warehouse_time: "2020-12-23 00:00:00.000",
    //       rough_weight: 50,
    //       tare_weight: 20,
    //       net_weight: 30,
    //       receiver_name: "0000000440A",
    //       entry_time: "2020-12-23 15:17:15.693",
    //       inventory_code: "1010-00000-008",
    //       inventory_name: "测试自由",
    //       inventory_unit: "pcs",
    //       state: 1,
    //       acceptance_time: 0,
    //       acceptance_user_id: "",
    //       acceptance_user_name: null
    //     },
    //     {
    //       id: "a9ac3a821d7249f3aec6a46249fdd33a",
    //       booking_id: "0ea8e8dad61349479f7e33b286e5102a",
    //       create_time: 1608708019,
    //       update_time: 1608708019,
    //       info_state: 0,
    //       license_plate: "宁978944",
    //       receipt_number: "0000000440A",
    //       warehouse_name: "TSW原料仓",
    //       entry_warehouse_time: "2020-12-23 00:00:00.000",
    //       rough_weight: 50,
    //       tare_weight: 20,
    //       net_weight: 30,
    //       receiver_name: "0000000440A",
    //       entry_time: "2020-12-23 15:17:15.693",
    //       inventory_code: "1010-00000-008",
    //       inventory_name: "测试自由",
    //       inventory_unit: "pcs",
    //       state: 0,
    //       acceptance_time: 0,
    //       acceptance_user_id: "",
    //       acceptance_user_name: null
    //     }
    //   ]
    // };

    this.showPage = true;
  }
};
</script>
<style lang="less" scoped>
.weighbridgeSysIndex {
  background: #f4f5f6;
  font-size: 16px;
  .top-cont {
    padding: 14px 16px 14px 16px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .s1 {
      display: inline-block;
      padding-right: 15px;
    }
    .s2 {
      display: inline-block;
      padding-right: 15px;
      font-weight: bold;
    }
    .licensePlate {
      display: inline-block;
      background: #e5f3ee;
      padding: 5px 7px;
      color: #008b5e;
      margin-right: 14px;
      border-radius: 2px;
    }
  }

  .top-cont-text {
    padding: 0px 16px 14px;
    background: #fff;
    display: flex;
    .left {
      flex: 1;
      text-align: right;
      margin-right: 30px;
      vertical-align: top;
      color: #b2b2b2;
    }
    .right {
      flex: 1.7;
      vertical-align: top;
      word-break: break-all;
    }
  }

  .materielListDiv {
    margin-top: 18px;
    padding-top: 16px;
    background: #fff;
    .title {
      font-size: 17px;
      color: rgba(0, 0, 0, 0.8);
      text-align: center;
      padding-bottom: 18px;
      .s1 {
        color: #008b5e;
        font-size: 20px;
      }
    }
    .van-divider {
      margin-top: 0;
    }
    .bookingCodeDiv {
      padding: 0 0 0 16px;
      // display: flex;
      // overflow: auto;
      > div {
        padding-right: 10px;
        padding-bottom: 10px;
        display: inline-block;
      }
    }
    .itemAction {
      text-align: center;
      padding: 5px 16px 20px 16px;
      > button {
        width: calc(100% - 32px);
        height: 49px;
        font-size: 18px;
      }
    }
  }
  .van-button--primary {
    font-size: 16px;
    padding: 6px 0;
    width: 107px;
    height: auto;
    color: #fff;
    border: 1px solid #008b5e;
    background-color: #008b5e;
  }
  .van-button--plain.van-button--primary {
    background-color: #fff;
    color: #008b5e !important;
  }
  .dialog-blk {
    text-align: center;
    margin: 15px 17px 28px;
    font-size: 17px;
    color: #666666;
    line-height: 26px;
  }
  .dialogBtnConfirm {
    border: 1px solid #eee;
    background: #fff;
    font-size: 17px;
    color: #008b5e;
    letter-spacing: 1px;
    text-align: center;
    line-height: 23.8px;
    height: 55px;
  }
  .dialogBtnCancel {
    border: 1px solid #eee;
    color: #000;
    background: #fff;
    font-size: 17px;
    letter-spacing: 1px;
    text-align: center;
    line-height: 23.8px;
    height: 55px;
  }
}
</style>
